// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';
import { restrictionHandling } from '../../../models/external_service_access_restrictions/ExternalServiceAccessRestriction';

export default class ShowView extends JQueryView {
  constructor() {
    super('.director_meetings.show');
  }

  @on({ event: 'click', selector: '.title-header' })
  clickToggleContent(e: any) {
    const chevronTarget = $(e.target).prev();
    const contentTarget = $(e.target)
      .parent()
      .next();

    if (contentTarget.hasClass('d-none')) {
      chevronTarget.removeClass('ion-chevron-right');
      chevronTarget.addClass('ion-chevron-up');
      contentTarget.removeClass('d-none');
    } else {
      chevronTarget.removeClass('ion-chevron-up');
      chevronTarget.addClass('ion-chevron-right');
      contentTarget.addClass('d-none');
    }
  }

  @on({
    event: 'click',
    selector: 'button.to-new-company-director-meeting-minute-execute-sign',
  })
  onClickToNewCompanyDirectorMeetingMinuteExecuteSign(
    event: SyntheticEvent<HTMLButtonElement>,
  ) {
    const to = event.currentTarget.dataset.to;
    restrictionHandling('WAN-Sign', () => {
      window.location = to;
    });
  }
}
